import React from 'react'
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import { useState, useEffect, useMemo, useContext } from "react";
import { ColorModeContext, useMode } from "../theme";
import { 
  CssBaseline, 
  ThemeProvider, 
  Chip, 
  ButtonGroup, 
  Alert, 
  Fab, 
  Tooltip,
  Autocomplete,
  Card,
  Modal,
  CardContent,
  CardHeader,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
  ListItem, 
  ListItemText, 
  List
} from "@mui/material";
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import { decode } from "base-64";
import Header from "../components/Header";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import { DataGrid, GridToolbar, GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Tab from '@mui/material/Tab';
// import useApiPrivate from '../auth/useApiPrivate';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import AuthContext from "../auth/AuthProvider";
import { api } from '../api';
import { fetchToken, fetchRole } from '../auth/Token';
import { ExpandMore, CheckCircle } from "@mui/icons-material";
import { useLocation, useNavigate } from 'react-router-dom';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import VerifiedIcon from '@mui/icons-material/Verified';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import JoinRightIcon from '@mui/icons-material/JoinRight';
import SourceIcon from '@mui/icons-material/Source';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import {FormatedDate} from '../components/SavingsDetails';
import SendIcon from '@mui/icons-material/Send';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Popper from '@mui/material/Popper';
import MenuList from '@mui/material/MenuList';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import SummarizeIcon from '@mui/icons-material/Summarize';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import KPeeLogo from '../LogoKPee1.png';
import SaveIcon from '@mui/icons-material/Save';
import Divider from '@mui/material/Divider';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import MainAccounts from './MainAccounts';
import './../working.css';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import BalanceIcon from '@mui/icons-material/Balance';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { toast } from 'sonner';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    borderStyle: 'groove',
    border: '3px',
    borderColor:'grey',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)',
    marginTop: '10px',
    minHeight:'50px',
    borderRadius:'10px'
  }));

  const ItemCard = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    borderStyle: 'groove',
    margin: '20px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.2)',
    marginTop: '10px',
    minHeight:'150px',
    minWidth:'300px',
    borderRadius:'15px',
    '&:hover': {
        boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
        borderW: '15px',
        borderColor:'#7C0902',
    },
  }));

  const ItemCardy = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    margin: '15px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.2)',
    borderRadius:'20px'
  }));

const OneCommodity = ({view_id, handleCancelView, view_data}) => {

    const currencyFormat = new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
    });
    return(
        <Grid container spacing={2}>
            <Grid item xs={12} md={12} sx={{ display:'flex', flexDirection:'row' }}>
                <IconButton sx={{ mr:'auto' }} onClick={handleCancelView}><ArrowBackIcon /></IconButton>
                <Typography variant='h4' sx={{ mr:'auto', textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{view_data?.commodity}</b></Typography>
            </Grid>
            <Grid item xs={12} md={12}>
                <Typography  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Total Bags: {view_data?.commodity_bags}</b></Typography>
                <Typography  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Value: {currencyFormat.format(view_data?.value)}</b></Typography>
            </Grid>
            <Grid item xs={12} md={12}>
                <Box sx={{ 
                    display:'flex',
                    // justifyContent:'center',
                    // alignItems:'center',
                    maxWidth: 1000,
                    overflowX: 'auto', 
                    '&::-webkit-scrollbar': {
                    height: '5px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: '#888',
                        borderRadius: '10px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        background: '#555',
                    }
                }}>
                    {
                        view_data?.grades?.map((view) => (
                            <ItemCardy>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <Typography 
                                            sx={{ 
                                                textAlign:'center' 
                                            }} 
                                            variant='h3'
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                            <b>{view.grade}</b>
                                        </Typography>
                                        <Typography 
                                            sx={{ 
                                                textAlign:'center' 
                                            }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                            <b>{view.grade_bags} bags</b>
                                        </Typography>
                                        <Typography 
                                            sx={{ 
                                                textAlign:'center' 
                                            }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                            <b>{currencyFormat.format(view.grade_price)}/bag</b>
                                        </Typography>
                                        <Typography 
                                            sx={{ 
                                                textAlign:'center' 
                                            }}
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                            <b>{currencyFormat.format(view.grade_value)}</b>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12} sx={{ display:'flex', flexDirection:'row' }}>
                                        {
                                            view?.bags_unit.map((unit) => (
                                                <ItemCardy>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography 
                                                                sx={{ 
                                                                    textAlign:'center' 
                                                                }}
                                                                variant='h4'
                                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                            >
                                                                <b>{unit.unit}kg</b>
                                                            </Typography>
                                                            <Typography 
                                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                            >
                                                                <b>{unit.bags} bags</b>
                                                            </Typography>
                                                            <Typography 
                                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                            >
                                                                <b>{currencyFormat.format(unit.unit_value)}</b>
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </ItemCardy>
                                            ))
                                        }
                                    </Grid>
                                </Grid>
                            </ItemCardy>
                        ))
                    }
                </Box>
            </Grid>
        </Grid>
    )

}

const SocietyWarehouse = ({id, name}) => {
    const {  permissions } = useContext(AuthContext);
    const [data, setData] = useState([])
    const [openn, setOpenn] = React.useState(false);
    const [open_modal, setOpen_modal] = useState(false);
    const [banks_accounts, setBanks_accounts] = useState([])
    const [bank_id, setBank_id] = useState(null);
    const [ledgers, setLedgers] = useState([]);
    const [ledger_id, setLedger_id] = useState(null);
    const [amount, setAmount] = useState(null);
    const [narration, setNarration] = useState(null);
    const [value, setValue] = useState(0);
    const [trs_typ, setTrs_type] = useState(null);
    const [commodity, setCommodity] = useState(false);
    const [view_id, setView_id] = useState(false);
    const [view_data, setView_data] = useState([]);
    const navigate = useNavigate()
    const [all_warehouse, setAll_warehouse] = useState([])
    const [wer_house_id, setWer_house_id] = useState(null)
    const [trade_data, setTrade_data] = useState([])
    const [open_modal_print, setOpen_modal_print] = useState(false);
    const [details_print, setDetails_print] = useState({});


    const confirm_pick_up = (one_deal) => {
        const data = new FormData()
        data.append('society_id', id)
        data.append('grade', one_deal.grade)
        data.append('unit', one_deal.unit)
        data.append('bags', one_deal.bags)
        data.append('trade_id', one_deal.trade_id)

        toast.promise(
            api.post('/societywarehouse/pick/up/bags/from/main/warehouse', data, {
            headers: {
                Authorization: 'Bearer ' + fetchToken()
            }
            }),
            {
            loading: 'Finishing Up...',
            success: (response) => {
                fetchSocietyData()
                return response.data
            },
            error: (error) => {
                console.log(error)
                return "An Error Occurred. Please try again"
            }
            }
        )
    }
  
    const printRefer = React.useRef();
  
    const handlePrinter = async () => {
      const element = printRefer.current;
      const canvas = await html2canvas(element);
      const data = canvas.toDataURL("image/png");
  
      const pdf = new jsPDF();
      const imgProperties = pdf.getImageProperties(data);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
  
      const marginLeft = 25;
      const marginTop = 25;
      const marginRight = 25;
      const marginBottom = 25;
  
      pdf.addImage(
        data,
        "PNG",
        marginLeft,
        marginTop,
        pdfWidth - marginLeft - marginRight,
        pdfHeight - marginTop - marginBottom
      );
  
      pdf.save("TradeInvoice.pdf");
    };
  
    const style_print = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "50%",
      maxHeight: "95vh",
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "7px",
        height: "7px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
      bgcolor: "background.paper",
      border: "1px solid #e7ecef",
      borderRadius: "7px",
      boxShadow: 24,
      p: 4,
    };
  
    const printReceipt = (data) => {
      setDetails_print(data)
      setOpen_modal_print(true);
    };
  
    const closeModalReceipt = () => {
      setOpen_modal_print(false);
    };


    const getCommoditiesAccount = () => {
    api.get(`/account/commodity/${id}`, {
        headers :{
        Authorization: 'Bearer '+ fetchToken()
        }
    }).then(function (response) {
        setAll_warehouse(response.data?.Warehouse);
    }).catch(function (error){
        console.log(error)
    }); 
    }

    const visitHouse = (ware_id, name) => {
        navigate('/warehouse', {state: { 
            id:ware_id,
            name:name,
            society:name,
            society_id:id,
            cash_worth: 0
        }});
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleView = (id, stocks) => {
        setView_id(id)
        setCommodity(true)
        setView_data(stocks)
    }

    const handleCancelView = (id) => {
        setCommodity(false)
        setView_id(null)
        setView_data([])
    }



    const printRef = React.useRef();

    const handlePrint = async () => {
        const element = printRef.current;
        const canvas = await html2canvas(element);
        const data = canvas.toDataURL('image/png');
    
        const pdf = new jsPDF();
        const imgProperties = pdf.getImageProperties(data);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
    
        
        const marginLeft = 25;
        const marginTop = 25;
        const marginRight = 25;
        const marginBottom = 25; 
    
        pdf.addImage(
        data,
        'PNG',
        marginLeft,
        marginTop,
        pdfWidth - marginLeft - marginRight,
        pdfHeight - marginTop - marginBottom
        );
    
        pdf.save('SocietyWarehouseCashRecords.pdf');
    }

    const handleOpenModal = (trs) => {
        setOpen_modal(true);
        setTrs_type(trs);
    };
    const handleCloseModal = () => {
        setOpen_modal(false);
        setBank_id(null);
        setLedger_id(null);
        setAmount(null)
        setWer_house_id(null)
    };

    const handleCloseBackdrop = () => {
      setOpenn(false);
    };
    const handleOpenBackdrop = () => {
      setOpenn(true);
    };

    function formatDateToYearMonthDayTime(date) {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        let suffix = 'th';
      
        if (day === 1 || day === 21 || day === 31) {
          suffix = 'st';
        } else if (day === 2 || day === 22) {
          suffix = 'nd';
        } else if (day === 3 || day === 23) {
          suffix = 'rd';
        }
      
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const minutesStr = minutes < 10 ? '0' + minutes : minutes;
    
        return `${day}${suffix} ${month} ${year}, ${hours}:${minutesStr} ${ampm}`;
    }

    

    const activateWarehouse = () => {
        handleOpenBackdrop()

        api.get(`/societywarehouse/activate/society/warehouse/${id}`,{
            headers: {
                Authorization:'Bearer ' + fetchToken(),
            },
          }).then(function (response) {
            toast.success(response.data)
            fetchSocietyData();
          }).catch(function (error){
              console.log(error)
          }).finally(function (){
            handleCloseBackdrop()
          })
    }

    const fetchSocietyData = () => {
        api.get(`/societywarehouse/society/warehouse/data/${id}`, {
            headers: {
                Authorization:'Bearer ' + fetchToken(),
            },
        }).then(function (response) {
            setData(response.data);
        }).catch(function (error){
            console.log(error)
        })

        api.get(`/account/society/all/${id}`,{
        headers: {
            Authorization:'Bearer ' + fetchToken(),
        },
        }).then(function (response) {
        setBanks_accounts(response.data?.Accounts);
        }).catch(function (error){
            console.log(error)
        })
      
        api.get(`/account/one/ledger/account/${id}`,{
        headers: {
            Authorization:'Bearer ' + fetchToken(),
        },
        }).then(function (response) {
        setLedgers(response.data?.ledgers);
        }).catch(function (error){
            console.log(error)
        })

        api.get(`/societywarehouse/get/vendors/deals/main/warehouse/${id}`,{
        headers: {
            Authorization:'Bearer ' + fetchToken(),
        },
        }).then(function (response) {
            setTrade_data(response.data?.trade_data);
        }).catch(function (error){
            console.log(error)
        })
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        maxHeight: '80vh', 
        overflowY: 'auto', 
        '&::-webkit-scrollbar': {
            width: '7px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
        },
        bgcolor: 'background.paper',
        border: '1px solid #e7ecef',
        borderRadius: '13px',
        boxShadow: 24,
        p: 4,
      };

    const deleteTrs = (id) => {
        handleOpenBackdrop();
        api.delete(`/societywarehouse/delete/society/warehouse/transaction/${id}`, {
            headers: {
                Authorization:'Bearer ' + fetchToken(),
            },
        }).then(function (response) {
            toast.success(response.data)
        }).catch(function (error){
            console.log(error)
        }).finally(function(){
            fetchSocietyData();
            handleCloseBackdrop()
        })
    }

    const handleFundAccount = () => {
        handleOpenBackdrop();
        const datas = new FormData()
        datas.append('bank_id', bank_id?bank_id:0)
        datas.append('society_warehouse_id', data?.data?.id)
        datas.append('transaction_type', trs_typ)
        datas.append('narration', narration)
        datas.append('ledger_id', ledger_id?ledger_id:0)
        datas.append('amount', amount)
        datas.append('wer_house_id', wer_house_id?wer_house_id:0)
        
        api.post('/societywarehouse/society/warehouse/fund/account', datas, {
          headers: {
              Authorization:'Bearer ' + fetchToken(),
          },
        }).then(function (response) {
          toast.success(response.data)
          handleCloseModal();
        }).catch(function (error){
            console.log(error)
        }).finally(function(){
          fetchSocietyData();
          handleCloseBackdrop()
        })
      }

    useEffect(() => {
        fetchSocietyData();
        getCommoditiesAccount();
    },[])

    const currencyFormat = new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
    });

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <Typography variant='h3' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign:'center' ,m: 1 }}><b>Society's Main Warehouse</b></Typography>
                </Grid>
                {
                    data?.exist === true?
                        null
                    :
                    <Grid item xs={12} md={12}>
                        <Chip 
                            size='medium'
                            label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Activate Warehouse</b></Typography>}
                            sx={{
                                borderRadius:2,
                                m:'auto',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                backgroundColor: 'green',
                                color:'#fff',
                                '&:hover': {
                                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                    backgroundColor:'#14213d',
                                },
                            }} 
                            onClick={activateWarehouse}
                        />
                    </Grid>
                }
                
                {/* Cash Account */}
                <Grid item xs={12} md={5}>
                    <Item>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12}>
                                <Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Warehouse Current Balance</b></Typography>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Typography variant='h2' textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(data?.data?.current_balance?data?.data?.current_balance:0)}</b></Typography>   
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Divider variant='middle' sx={{ m:1 }} />
                                <Box sx={{display:'flex', flexDirection:'row'}}>
                                <Chip 
                                    size='small'
                                    label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Fund Account</b></Typography>}
                                    sx={{
                                        borderRadius:2,
                                        m: 1,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                        backgroundColor: 'green',
                                        color:'#fff',
                                        '&:hover': {
                                            boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                            backgroundColor:'#14213d',
                                            color:'#fff'
                                        },
                                    }} 
                                    onClick={() => handleOpenModal(1)}
                                />
                                <Chip 
                                    size='small'
                                    label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Release funds</b></Typography>}
                                    sx={{
                                        borderRadius:2,
                                        m: 1,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                        backgroundColor: 'orange',
                                        color:'#000',
                                        '&:hover': {
                                            boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                            backgroundColor:'#14213d',
                                            color:'#fff'
                                        },
                                    }} 
                                    onClick={() => handleOpenModal(2)}
                                />
                                <Chip 
                                    size='small'
                                    label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Fund Local Warehouse</b></Typography>}
                                    sx={{
                                        borderRadius:2,
                                        m: 1,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                        backgroundColor: 'brown',
                                        color:'#fff',
                                        '&:hover': {
                                            boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                            backgroundColor:'#14213d',
                                            color:'#fff'
                                        },
                                    }} 
                                    onClick={() => handleOpenModal(3)}
                                />
                                </Box>
                            </Grid>
                            </Grid>
                    </Item>

                    <Item>
                        
                    <Box sx={{ m:1 }}>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Vendors Trade Deals in Main Warehouse (Bags moved here)</b>
                                        </Typography>
                                    </Box>
                                    <Box sx={{
                                        m:1,
                                        overflow: 'auto', 
                                        // maxWidth: 1250, 
                                        maxHeight: 600,
                                        '&::-webkit-scrollbar': {
                                            height: '7px',
                                            width: '7px',
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            background: '#f1f1f1',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            background: '#888',
                                            borderRadius: '10px',
                                        },
                                        '&::-webkit-scrollbar-thumb:hover': {
                                            background: '#555',
                                        } 
                                    }}>
                                        <Table size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow>
                                            <TableCell align="left"><Typography variant="h6"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Pick Up</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography variant="h6"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Print</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography variant="h6"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Vendor Name</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography variant="h6"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Commodity</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography variant="h6"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Bags</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography variant="h6"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Price</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography variant="h6"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Trade Status</b>
                                            </Typography> </TableCell>
                                            {/* <TableCell align="left"><Typography variant="h5"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Prepared by</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Vendor Name</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Bank Account(if applicable)</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Warehouse(if applicable)</b>
                                            </Typography> </TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {trade_data?.map((row) => (
                                            <TableRow
                                                key={row.trade_id}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor:'#f5f3f4' }}
                                            >
                                                 <TableCell align="left">
                                                   <Chip 
                                                        size='small'
                                                        label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.trade_status === "Closed"?'Confirmed':'Confirm Pick Up'}</b></Typography>}
                                                        disabled={row.trade_status === "Closed"}
                                                        sx={{
                                                            borderRadius:2,
                                                            m:'5px',
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                                            backgroundColor: 'green',
                                                            color:'#fff',
                                                            '&:hover': {
                                                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                                backgroundColor:'#14213d',
                                                            },
                                                        }} 
                                                        onClick={() => confirm_pick_up(row)}
                                                        />
                                                    

                                                </TableCell>
                                                <TableCell align="left">
                                                   <Chip 
                                                        size='small'
                                                        label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Invoice</b></Typography>}
                                                        sx={{
                                                            borderRadius:2,
                                                            m:'5px',
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                                            backgroundColor: 'green',
                                                            color:'#fff',
                                                            '&:hover': {
                                                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                                backgroundColor:'#14213d',
                                                            },
                                                        }} 
                                                        onClick={() => printReceipt(row)}
                                                        />
                                                    

                                                </TableCell>
                                                <TableCell align="left"><Typography variant="h6" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.vendor_name}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography variant="h6" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.commodity}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography variant="h6" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.bags}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography variant="h6" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(row.price)}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography variant="h6" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.trade_status}</b></Typography></TableCell>
                                                {/* <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.username}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.vendor_name}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.account_name}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.warehouse}</b></Typography></TableCell> */}
                                               
                                            </TableRow>
                                            ))}
                                        </TableBody>
                                        </Table>
                                    </Box>
                        
                    </Item>
                </Grid>
                <Modal
                            open={open_modal_print}
                            onClose={closeModalReceipt}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <Box sx={style_print}>
                              <Grid container spacing={2}>
                                <Grid item xs={12} md={12}>
                                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                                    <Chip
                                      size="medium"
                                      label={
                                        <Typography
                                          variant="subtitle"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>Print</b>
                                        </Typography>
                                      }
                                      sx={{
                                        borderRadius: 2,
                                        mr: "auto",
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        backgroundColor: "orange",
                                        color: "#000",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                          color: "#fff",
                                        },
                                      }}
                                      onClick={handlePrinter}
                                    />
                                    <Chip
                                      size="medium"
                                      label={
                                        <Typography
                                          variant="subtitle"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>Close</b>
                                        </Typography>
                                      }
                                      sx={{
                                        borderRadius: 2,
                                        ml: "auto",
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        backgroundColor: "red",
                                        color: "#fff",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                          color: "#fff",
                                        },
                                      }}
                                      onClick={closeModalReceipt}
                                    />
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                  <Grid container spacing={2} ref={printRefer}>
                                    <Grid item xs={12} md={12}>
                                      <Typography
                                        variant="subtitle"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        textAlign="center"
                                        sx={{ color: "grey", mb: 3, ml: "43%" }}
                                      >
                                        <b>~ The Cooperative ~</b>
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                      <Avatar
                                        src={KPeeLogo}
                                        alt="KPee logo"
                                        sx={{ width: 120, height: 120, m: "auto" }}
                                      />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                      <Typography
                                        variant="h3"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        sx={{ textAlign: "center" }}
                                      >
                                        <b>{name}</b>
                                      </Typography>
                                      <Typography
                                        sx={{textAlign:'center'}}
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>{formatDateToYearMonthDayTime(new Date())}</b>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} md={12}>
                                      <Typography
                                        sx={{ textAlign: "center", textDecoration: "underline" }}
                                        variant="h4"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Vendor</b>
                                      </Typography>

                                      <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Name:{" "} {details_print?.vendor_name}</b>
                                      </Typography>
                                      {/* <Divider variant="middle" /> */}
                                      <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Email:{" "} {details_print?.email}</b>
                                      </Typography>
                                      {/* <Divider variant="middle" /> */}
                                      <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Phone Contact:{" "} {details_print?.phone}</b>
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} md={12}>
                                      <Typography
                                        sx={{ textAlign: "center", textDecoration: "underline" }}
                                        variant="h4"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Trade Deal</b>
                                      </Typography>

                                      <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Commodity:{" "} {details_print?.commodity}</b>
                                      </Typography>
                                      {/* <Divider variant="middle" /> */}
                                      <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>
                                          Number of Bags:{" "}
                                          {currencyFormat.format(details_print?.bags)}
                                        </b>
                                      </Typography>
                                      {/* <Divider variant="middle" /> */}
                                      <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>
                                          Commodity Grade:{" "} {details_print?.grade}
                                        </b>
                                      </Typography>
                                      {/* <Divider variant="middle" /> */}
                                      <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Commodity Bag Unit: {details_print?.unit}kg</b>
                                      </Typography>
                                      {/* <Divider variant="middle" /> */}
                                      <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Pick Up Point:{" "} {details_print?.pick_up_point === 'Local Warehouse'?details_print?.warehouse:'Main Warehouse'}</b>
                                      </Typography>
                                      {/* <Divider variant="middle" /> */}
                                      <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Pick Up Date:{" "} {details_print?.pick_up_date?formatDateToYearMonthDayTime(new Date(details_print?.pick_up_date)):'Not Confirmed'}</b>
                                      </Typography>
                                      {/* <Divider variant="middle" /> */}
                                      <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Amount Paid: {currencyFormat.format(details_print?.price)}</b>
                                      </Typography>
                                      <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>
                                          Selling Bag Price(single):{" "} {currencyFormat.format(details_print?.price / details_print?.bags)}
                                        </b>
                                      </Typography>
                                      {/* <Divider variant="middle" /> */}
                                    </Grid>

                                    <Grid item xs={12} md={12}>
                                      <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Deal Status:{" "} {details_print?.trade_status}</b>
                                      </Typography>
                                    </Grid>
                                    
                                    <Grid  item xs={12} md={12}>
                                      <Typography sx={{textAlign:'center', mt:5}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>It was a pleasure doing business with you.</b>
                                      </Typography>
                                    </Grid>
                                  </Grid>

                                </Grid>
                              </Grid>
                              
                            </Box>
                          </Modal>
                {/* Stock Account */}
                <Grid item xs={12} md={7}>
                    <Item>
                        {
                            !commodity?
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={12}>
                                    <Box sx={{ 
                                        display:'flex',
                                        // justifyContent:'center',
                                        // alignItems:'center',
                                        maxWidth: 700,
                                        overflowX: 'auto', 
                                        '&::-webkit-scrollbar': {
                                        height: '5px',
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            background: '#f1f1f1',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            background: '#888',
                                            borderRadius: '10px',
                                        },
                                        '&::-webkit-scrollbar-thumb:hover': {
                                            background: '#555',
                                    }
                                    }}>
                                        {
                                            data?.stocks?.map((commodity) => (
                                                <ItemCard>
                                                    <Grid container spacing={2} onClick={() => handleView(commodity.id, commodity)}>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography 
                                                                sx={{ 
                                                                    textAlign:'center' 
                                                                }} 
                                                                variant='h3'
                                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                            >
                                                                <b>{commodity.commodity}</b>
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={12} md={12}>
                                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Total bags: {commodity.commodity_bags}</b></Typography>
                                                            <Box sx={{ display:'flex', flexDirection:'row' }}>
                                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Current Value: {currencyFormat.format(commodity.value)} </b></Typography>
                                                                <BalanceIcon sx={{ml:3}}/> 
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} md={12}>
                                                            {
                                                                commodity?.grades.map((grade) => (
                                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{grade.grade}: {grade.grade_bags}bags</b></Typography>
                                                                ))
                                                            }
                                                         </Grid>
                                                    </Grid>
                                                </ItemCard>
                                            ))
                                        }
                                    </Box>
                                </Grid>
                            </Grid>
                            :
                            <OneCommodity view_id={view_id} handleCancelView={handleCancelView} view_data={view_data}/>
                        }
                        
                    </Item>
                </Grid>
                {/* Records */}
                <Grid item xs={12} md={12}>
                    <Item>
                        <Box sx={{ m:1 }}>
                            <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Records</b></Typography>
                        </Box>
                        <Box>
                            <Tabs
                                variant="fullWidth"
                                value={value}
                                onChange={handleChange}
                                aria-label="basic tabs example"
                                sx={{ 
                                    backgroundColor:'#e9ecef', 
                                    borderRadius:7, 
                                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                    transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                                    '&:hover': {
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                    backgroundColor:'#f8f9fa',
                                    },
                                }}
                                >
                                <Tab label={<b style={{ color: '#2b2d42', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Cash Records</b>} {...a11yProps(0)} />
                                <Tab label={<b style={{ color: '#2b2d42', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Stock Records</b>} {...a11yProps(1)} />
                            </Tabs>
                            <CustomTabPanel value={value} index={0}>
                                <Box sx={{ display:'flex', flexDirection:'row' }}>
                                    {/* <Chip 
                                        size='medium'
                                        label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Print</b></Typography>}
                                        sx={{
                                            borderRadius:2,
                                            mr:'auto',
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                            backgroundColor: 'orange',
                                            color:'#000',
                                            '&:hover': {
                                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                backgroundColor:'#14213d',
                                                color:'#fff',
                                            },
                                        }} 
                                        onClick={handlePrint}
                                    /> */}
                                </Box>
                                <Box ref={printRef}>
                                    <Box sx={{ m:1 }}>
                                        <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Account Transactions</b>
                                        </Typography>
                                    </Box>
                                    <Box sx={{
                                        m:1,
                                        overflow: 'auto', 
                                        minWidth: 1250, 
                                        maxHeight: 600,
                                        '&::-webkit-scrollbar': {
                                            height: '7px',
                                            width: '7px',
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            background: '#f1f1f1',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            background: '#888',
                                            borderRadius: '10px',
                                        },
                                        '&::-webkit-scrollbar-thumb:hover': {
                                            background: '#555',
                                        } 
                                    }}>
                                        <Table size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Date</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Kind</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Debit</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Credit</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Balance</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Prepared by</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Vendor Name</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Bank Account(if applicable)</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Warehouse(if applicable)</b>
                                            </Typography> </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data?.account_transactions?.map((row) => (
                                            <TableRow
                                                key={row.transaction_id}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor:'#f5f3f4' }}
                                            >
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{formatDateToYearMonthDayTime(new Date(row.date))}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.transaction_kind}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.transaction_type === 2? currencyFormat.format(row.amount): currencyFormat.format(0)}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.transaction_type === 1? currencyFormat.format(row.amount): currencyFormat.format(0)}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(row.balance)}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.username}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.vendor_name}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.account_name}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography onClick={() => visitHouse(row.warehouse_id, row.warehouse)} sx={{ textDecoration:'underline', cursor:'pointer' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.warehouse}</b></Typography></TableCell>
                                                <TableCell align="left">
                                                    <Box  sx={{ display:'flex', flexDirection:'row' }}>
                                                    
                                                    <Tooltip title={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>NB: This feature will check if the amount invested still exist in society account before deleting. It will ignore if society account does not have sufficient balance to be deducted.</b></Typography>}>
                                                        <Chip 
                                                        size='small'
                                                        label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Delete</b></Typography>}
                                                        sx={{
                                                            borderRadius:2,
                                                            m:'5px',
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                                            backgroundColor: 'red',
                                                            color:'#fff',
                                                            '&:hover': {
                                                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                                backgroundColor:'#14213d',
                                                            },
                                                        }} 
                                                        onClick={() => deleteTrs(row.transaction_id)}
                                                        />
                                                    </Tooltip>
                                                    
                                                    </Box>
                                                    

                                                </TableCell>
                                            </TableRow>
                                            ))}
                                        </TableBody>
                                        </Table>
                                    </Box>
                                </Box>
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={1}>
                                <Box>
                                    {/* <Chip 
                                        size='medium'
                                        label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Print</b></Typography>}
                                        sx={{
                                            borderRadius:2,
                                            mr:'auto',
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                            backgroundColor: 'orange',
                                            color:'#000',
                                            '&:hover': {
                                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                backgroundColor:'#14213d',
                                                color:'#fff',
                                            },
                                        }} 
                                        onClick={handlePrint}
                                    /> */}
                                </Box>
                                <Box ref={printRef}>
                                    <Box sx={{ m:1 }}>
                                        <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Stocks Transactions</b>
                                        </Typography>
                                    </Box>
                                    <Box sx={{
                                        m:1,
                                        overflow: 'auto', 
                                        minWidth: 1250, 
                                        maxHeight: 600,
                                        '&::-webkit-scrollbar': {
                                            height: '7px',
                                            width: '7px',
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            background: '#f1f1f1',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            background: '#888',
                                            borderRadius: '10px',
                                        },
                                        '&::-webkit-scrollbar-thumb:hover': {
                                            background: '#555',
                                        } 
                                    }}>
                                        <Table size="small" aria-label="a dense table">
                                        <TableHead>
                                            <TableRow>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Transfer Date</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Commodity</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Bags</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Grade</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Unit</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Warehouse (from)</b>
                                            </Typography> </TableCell>
                                            <TableCell align="left"><Typography
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b></b>
                                            </Typography> </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data?.stock_transactions?.map((row) => (
                                            <TableRow
                                                key={row.id}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor:'#f5f3f4' }}
                                            >
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{formatDateToYearMonthDayTime(new Date(row.transfer_date))}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.commodity}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.bags}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.grade}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.unit_per_kg}</b></Typography></TableCell>
                                                <TableCell align="left"><Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{row.warehouse}</b></Typography></TableCell>
                                                <TableCell align="left">
                                                    <Chip 
                                                        size='small'
                                                        label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>View</b></Typography>}
                                                        sx={{
                                                            borderRadius:2,
                                                            m:'5px',
                                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                                            backgroundColor: 'brown',
                                                            color:'#fff',
                                                            '&:hover': {
                                                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                                backgroundColor:'#14213d',
                                                            },
                                                        }} 
                                                        onClick={() => visitHouse(row.ware_id, row.warehouse)}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                            ))}
                                        </TableBody>
                                        </Table>
                                    </Box>
                                </Box>               
                            </CustomTabPanel>
                        </Box>
                    </Item>
                </Grid>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={openn}
                    onClick={handleCloseBackdrop}
                >
                    <div className="wrapper">
                        <div className="circle"></div>
                        <div className="circle"></div>
                        <div className="circle"></div>
                        <div className="shadow"></div>
                        <div className="shadow"></div>
                        <div className="shadow"></div>
                    </div>
                </Backdrop>
            </Grid>

            <Modal
                open={open_modal}
                onClose={handleCloseModal}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={style}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <Typography variant='h4' textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>
                        {
                            trs_typ === 1?
                            'Fund Account':
                            trs_typ === 2?
                            'Release Amount'
                            :'Fund local warehouses'
                            
                        }
                            
                        </b></Typography>
                    </Grid>
                    {
                        trs_typ === 3?
                        <Grid item xs={12} md={12}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={all_warehouse}
                                getOptionLabel={(option) => option.warehouse}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                onChange={(event, value) => setWer_house_id(value.id)}
                                renderInput={(params) => <TextField {...params} helperText="Select Warehouse to fund" size="small" />}
                            />
                        </Grid>
                        :null
                    }
                    <Grid item xs={12} md={12}>
                        <TextField 
                            helperText={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Amount</b></Typography>}
                            size='small'
                            fullWidth
                            name='amount'
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            type='number'
                            inputProps={{ step: 'any' }}
                        />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <TextField 
                            helperText={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Narration (Optional)</b></Typography>}
                            size='small'
                            fullWidth
                            name='narration'
                            value={narration}
                            multiline
                            rows={4}
                            onChange={(e) => setNarration(e.target.value)}
                        />
                    </Grid>
                {
                    amount && trs_typ === 1?
                    <>
                        <Grid item xs={12} md={12}>
                    <Item>
                        <Box sx={{display:'flex', flexWrap:'wrap'}}>
                        {
                            banks_accounts?.map((bank) => (
                            <Chip 
                                size='small'
                                disabled={bank.current_balance < amount}
                                label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{bank.account_name} ({currencyFormat.format(bank.current_balance)})</b></Typography>}
                                sx={{
                                    borderRadius:2,
                                    m:1,
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                    backgroundColor: bank.id === bank_id? 'green' : 'white',
                                    color:'#000',
                                    '&:hover': {
                                        boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'green',
                                        color:'#fff'
                                    },
                                }} 
                                onClick={() => setBank_id(bank.id)}
                            />
                            ))
                        }
                        </Box>
                    </Item>
                    </Grid>
                    <Grid item xs={12} md={12}>
                    {
                        bank_id && trs_typ === 1?
                        ledgers && trs_typ === 1?
                        <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                        {
                            ledgers.map((ledg) => (
                            <>
                            <ListItem
                                alignItems="flex-start"
                                onClick={()=> setLedger_id(ledg.id)}
                                sx={{ backgroundColor:ledg.id === ledger_id? '#e9ecef' : 'white' }}
                                secondaryAction={
                                    <IconButton onClick={()=> setLedger_id(ledg.id)} edge="end" aria-label="comments">
                                    <CheckCircle color={
                                        ledg.id === ledger_id? 'success':'primary'
                                    }/>
                                    </IconButton>
                                }>
                                <ListItemText
                                primary={ledg.account_name}
                                secondary={
                                    <Box sx={{ display:'block' }}>
                                    <div>
                                    <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="body2"
                                        color="text.primary"
                                    >
                                        <b>{ledg.description}</b>
                                    </Typography>
                                    </div>
                                    </Box>
                                }
                                />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                            </>
                            ))
                        }
                        </List>
                        :<Typography textAlign='center' sx={{ m:3 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>No ledgers available</b></Typography>
                        :null
                    }
                    </Grid>
                    </>
                    :null
                }
                    <Grid item xs={12} md={12}>
                    <Box>
                        <Chip 
                            size='small'
                            label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Cancel</b></Typography>}
                            sx={{
                                borderRadius:2,
                                ml:'auto',
                                mr:1,
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                backgroundColor:'red',
                                color:'#fff',
                                '&:hover': {
                                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                    backgroundColor:'green',
                                    color:'#000'
                                },
                            }} 
                            onClick={handleCloseModal}
                        />
                        {
                            trs_typ === 1?
                            <Chip 
                                size='small'
                                disabled={!bank_id || !ledger_id}
                                label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Complete</b></Typography>}
                                sx={{
                                    borderRadius:2,
                                    ml:'auto',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                    backgroundColor: 'green',
                                    color:'#fff',
                                    '&:hover': {
                                        boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'white',
                                        color:'#000'
                                    },
                                }} 
                                onClick={handleFundAccount}
                            />
                            :
                            <Chip 
                                size='small'
                                disabled={!amount || amount > data?.data?.current_balance}
                                label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Complete</b></Typography>}
                                sx={{
                                    borderRadius:2,
                                    ml:'auto',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                    backgroundColor: 'green',
                                    color:'#fff',
                                    '&:hover': {
                                        boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'white',
                                        color:'#000'
                                    },
                                }} 
                                onClick={handleFundAccount}
                            />
                        }
                        
                    </Box>
                    </Grid>
                    
                    
                </Grid>
                </Box>
            </Modal>
        </LocalizationProvider>
    )
}
export default SocietyWarehouse